module.exports = __webpack_public_path__ + "static/slider_3-81ad5aa7b6c9ead51496aacccff7ec7b.jpg";